import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingPage from '../pages/LandingPage';
import TestCatalogPage from '../pages/TestCatalogPage';
import TestPlansPage from '../pages/TestPlansPage';
import AnalyticsPage from '../pages/AnalyticsPage';
import Changelog from '../components/Changelog';

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/testcatalog" element={<TestCatalogPage />} />
      <Route path="/testplans" element={<TestPlansPage />} />
      <Route path="/analytics" element={<AnalyticsPage />} />
      <Route path="/changelog" element={<Changelog />} />
    </Routes>
  );
}

export default AppRouter;
